import React from "react";
import PropTypes from "prop-types";
import { Column, Field, Control, Label, Input } from "rbx";

const AvoidWorkOrderForm = ({ inputs, onChange }) => (
  <div style={{ marginTop: "2rem" }}>
    <Column.Group>
      <Column>
        <Field>
          <Column.Group>
            <Column>
              <Field>
                <Control>
                  <Label>Reason</Label>
                  <Input
                    required
                    autoComplete="off"
                    name="VoidReason"
                    type="text"
                    value={inputs.VoidReason}
                    onChange={onChange}
                  />
                </Control>
              </Field>
            </Column>
          </Column.Group>
        </Field>
      </Column>
    </Column.Group>
  </div>
);
AvoidWorkOrderForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};

AvoidWorkOrderForm.defaultProps = {
  inputs: {}
};
export default AvoidWorkOrderForm;
